import truncatemixin from './truncate.mixin'
const MAX_NUMBERS_OF_CHARS = 500
export default {
  mixins: [truncatemixin],
  props: {
    contract: {
      type: Object,
      required: true
    }
  },
  computed: {
    truncatedText () {
      return this.truncate(this.contract.richText, MAX_NUMBERS_OF_CHARS)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/contract.mixin.js